import { askConfirm } from '../lib/askConfirm';
import { Trash2 } from 'lucide-react';
import MediaThumb from './MediaThumb';
import { SurveyPhotoBtn } from './SurveyPhoto';
import { surveyText, svyRefLabel, fmtM } from '../lib/survey';

export const SurveyPhotoBtns = ({ t, two, dists, refLabel, target, onAdd, prefix }) => (
  <>
    <SurveyPhotoBtn t={t} mode="a" dists={dists} refLabel={refLabel} target={target} onAdd={onAdd} testid={`${prefix}-photo-a-btn`} />
    {two && <SurveyPhotoBtn t={t} mode="b" dists={dists} refLabel={refLabel} target={target} onAdd={onAdd} testid={`${prefix}-photo-b-btn`} />}
    {two && <SurveyPhotoBtn t={t} mode="ab" dists={dists} refLabel={refLabel} target={target} onAdd={onAdd} testid={`${prefix}-photo-ab-btn`} />}
  </>
);

export const SurveyPhotoList = ({ t, photos, onDelete, prefix }) => !photos?.length ? null : (
  <div className="svy-photos">
    {photos.map((p, j) => (
      <div key={p.id} className="svy-photo" data-testid={`${prefix}-photo-${j}`}>
        <MediaThumb item={p} className="svy-photo-img" />
        {onDelete && <button className="icon-btn danger mini-del" data-testid={`${prefix}-photo-delete-${j}`} onClick={() => askConfirm(t.confirmDelPhoto).then((ok) => ok && onDelete(p.id))}><Trash2 size={12} /></button>}
      </div>
    ))}
  </div>
);

// "surveyed object" info box in the object sheet
export default function SurveyInfo({ t, s, title, target, onEdit, onPatch, testid }) {
  const ref = svyRefLabel(s.kindRef, t);
  const two = s.method === 'arc' && !!s.b;
  const kind = s.method === 'arc' ? t.svyKindArc : s.method === 'ortho' ? t.svyM_ortho : t.svyKindRay;
  const photos = s.photos || [];
  return (
    <div className="svy-info" data-testid={testid}>
      <b>📐 {title || t.svyInfoTitle}</b>
      <div data-testid={`${testid}-kind`}><small>{t.svyInfoKind}:</small> {kind}</div>
      <div data-testid={`${testid}-ref`}><small>{t.svyInfoRef}:</small> {s.method === 'ortho' ? surveyText(s, t)
        : <>{t.svyFrom} P1 ({ref}) = <b>{fmtM(s.da)}</b>{two && <> | {t.svyFrom} P2 ({ref} 2) = <b>{fmtM(s.db)}</b></>}</>}</div>
      {s.approx && <div className="svy-approx" data-testid={`${testid}-approx`}>⚠️ {t.svyApprox}</div>}
      <SurveyPhotoList t={t} photos={photos} prefix={testid} onDelete={(id) => onPatch({ ...s, photos: photos.filter((x) => x.id !== id) })} />
      <div className="svy-w-row">
        {s.method !== 'ortho' && <SurveyPhotoBtns t={t} two={two} dists={{ a: s.da, b: s.db }} refLabel={ref} target={target} prefix={testid} onAdd={(p) => onPatch({ ...s, photos: [...photos, p] })} />}
        <button className="btn btn-dark btn-sm" data-testid={`${testid}-edit-btn`} onClick={onEdit}>📐 {t.svyEdit}</button>
      </div>
    </div>
  );
}
